/**
 * 弹窗内产品变体：仅在打开弹窗时初始化；若需补全 JSON 则懒加载 /products/HANDLE.js（不占 Liquid all_products 配额）。
 * 懒加载期间弹窗显示 loading 层。
 */
function moftDialogStillOpen(dialogEl) {
  return dialogEl && dialogEl.classList.contains("moft-dialog--opened");
}

function moftDialogNeedsLazyProductJson(dialogEl) {
  var nodes = dialogEl.querySelectorAll("[data-js-callback] .nt_pr_js");
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].getAttribute("data-moft-nt-done") === "1") continue;
    if (nodes[i].getAttribute("data-moft-product-json-src")) return true;
  }
  return false;
}

function moftSetDialogProductLoading(dialogEl, on) {
  if (!dialogEl) return;
  if (on) dialogEl.classList.add("moft-dialog--product-loading");
  else dialogEl.classList.remove("moft-dialog--product-loading");
}

/**
 * @param {AbortSignal|null} signal
 * @returns {Promise<void>}
 */
function moftNtproductPageMaybeFetch(ntEl, dialogEl, signal) {
  if (!ntEl || typeof geckoShopify === "undefined" || typeof geckoShopify.NtproductPage !== "function") {
    return Promise.resolve();
  }
  if (ntEl.getAttribute("data-moft-nt-done") === "1") {
    return Promise.resolve();
  }
  var prId = ntEl.getAttribute("data-id");
  if (!prId) {
    return Promise.resolve();
  }
  var scriptEl = document.getElementById("ProductJson-template" + prId);
  if (!scriptEl) {
    try {
      if (moftDialogStillOpen(dialogEl)) {
        geckoShopify.NtproductPage(prId);
        ntEl.setAttribute("data-moft-nt-done", "1");
      }
    } catch (e) {
      console.warn("[dialog-product-quickview] NtproductPage failed (no script)", prId, e);
    }
    return Promise.resolve();
  }
  var src = ntEl.getAttribute("data-moft-product-json-src");
  if (src) {
    if (ntEl._moftInFlightPromise) {
      return ntEl._moftInFlightPromise;
    }
    ntEl.setAttribute("data-moft-nt-fetching", "1");
    ntEl._moftInFlightPromise = (window.originfetch || window.fetch)(src, { credentials: "same-origin", signal: signal || undefined })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!moftDialogStillOpen(dialogEl)) return;
        scriptEl.textContent = JSON.stringify(data);
        ntEl.removeAttribute("data-moft-product-json-src");
        try {
          geckoShopify.NtproductPage(prId);
          ntEl.setAttribute("data-moft-nt-done", "1");
        } catch (e) {
          console.warn("[dialog-product-quickview] NtproductPage failed after fetch", prId, e);
        }
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") return;
        console.warn("[dialog-product-quickview] product JSON fetch failed", src, err);
      })
      .finally(function () {
        ntEl.removeAttribute("data-moft-nt-fetching");
        delete ntEl._moftInFlightPromise;
      });
    return ntEl._moftInFlightPromise;
  }
  try {
    if (moftDialogStillOpen(dialogEl)) {
      geckoShopify.NtproductPage(prId);
      ntEl.setAttribute("data-moft-nt-done", "1");
    }
  } catch (e) {
    console.warn("[dialog-product-quickview] NtproductPage failed", prId, e);
  }
  return Promise.resolve();
}

/**
 * @param {AbortSignal|null} signal
 * @returns {Promise<void>}
 */
function moftInitNtproductInDialog(dialogEl, signal) {
  if (!dialogEl) return Promise.resolve();
  var nodes = dialogEl.querySelectorAll("[data-js-callback] .nt_pr_js");
  var tasks = [];
  for (var i = 0; i < nodes.length; i++) {
    tasks.push(moftNtproductPageMaybeFetch(nodes[i], dialogEl, signal));
  }
  return Promise.all(tasks).then(function () { });
}

function moftAbortDialogProductFetch(dialogEl) {
  if (!dialogEl || !dialogEl._moftProductJsonAbort) return;
  var ac = dialogEl._moftProductJsonAbort;
  dialogEl._moftProductJsonAbort = null;
  try {
    ac.abort();
  } catch (e) { }
}

if (!window.__moftDialogQuickviewInited) {
  window.__moftDialogQuickviewInited = true;

  $(document).ready(function () {
    const dialogBtnEls = document.querySelectorAll(".moft-show-dialog[data-moft-show-dialog]");
    if (dialogBtnEls.length <= 0) return;
    const overlayEl = document.querySelector(".mask-overlay");
    const htmlEl = document.querySelector("html");
    overlayEl.addEventListener("click", function (e) {
      const dialogEl = document.querySelector(".moft-dialog--opened");
      if (dialogEl) {
        moftAbortDialogProductFetch(dialogEl);
        moftSetDialogProductLoading(dialogEl, false);
        dialogEl.classList.remove("moft-dialog--opened");
        setTimeout(function () {
          dialogEl.style.display = "none";
        }, 301);
      }
      overlayEl.classList.remove("mask_opened");
      htmlEl.classList.remove("hside_opened");
    });
    for (let i = 0; i < dialogBtnEls.length; i++) {
      const dialogBtnEl = dialogBtnEls[i];
      dialogBtnEl.addEventListener("click", function (e) {
        const id = dialogBtnEl.getAttribute("data-dialog-id");
        const dialogEl = document.getElementById("moft-dialog__" + id);
        if (!dialogEl) return;

        var ac = typeof AbortController !== "undefined" ? new AbortController() : null;
        dialogEl._moftProductJsonAbort = ac;

        dialogEl.style.display = "block";
        dialogEl.classList.add("moft-dialog--opened");
        htmlEl.classList.add("hside_opened");
        overlayEl.classList.add("mask_opened");
        $(window).trigger("resize");
        geckoShopify.init();

        var needLazy = moftDialogNeedsLazyProductJson(dialogEl);
        moftSetDialogProductLoading(dialogEl, needLazy);

        moftInitNtproductInDialog(dialogEl, ac ? ac.signal : null).finally(function () {
          moftSetDialogProductLoading(dialogEl, false);
          if (dialogEl._moftProductJsonAbort === ac) delete dialogEl._moftProductJsonAbort;
        });
      });
    }
  });

  /** Dialog 关闭 */
  $(document).ready(function () {
    const dialogEls = document.querySelectorAll(".moft-dialog");
    if (dialogEls.length <= 0) return;
    const overlayEl = document.querySelector(".mask-overlay");
    const htmlEl = document.querySelector("html");
    for (let i = 0; i < dialogEls.length; i++) {
      const dialogEl = dialogEls[i];
      const closeBtnEl = dialogEl.querySelector(".moft-dialog__close");
      closeBtnEl.addEventListener("click", function () {
        moftAbortDialogProductFetch(dialogEl);
        moftSetDialogProductLoading(dialogEl, false);
        dialogEl.classList.remove("moft-dialog--opened");
        setTimeout(function () {
          dialogEl.style.display = "none";
        }, 301);
        overlayEl.classList.remove("mask_opened");
        htmlEl.classList.remove("hside_opened");
      });
    }
  });

  /** Dialog 与侧边 Cart */
  $(document).ready(function () {
    const dialogEl = document.querySelector(".moft-dialog");
    if (!dialogEl) return;
    const target = document.querySelector("body");
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
          if (target.classList.contains("pside_opened")) {
            const dialogEls = document.querySelectorAll(".moft-dialog");
            for (let el of dialogEls) {
              moftAbortDialogProductFetch(el);
              moftSetDialogProductLoading(el, false);
              el.classList.remove("moft-dialog--opened");
              setTimeout(function () {
                el.style.display = "none";
              }, 301);
            }
          }
        }
      });
    });
    observer.observe(target, { attributes: true });
  });
}